import { Component, OnDestroy, OnInit } from '@angular/core';
import * as $ from 'jquery';
import * as XLSX from 'xlsx';
import confetti from 'canvas-confetti';

@Component({
  selector: 'app-ganadores-egresados-2026',
  templateUrl: './ganadores-egresados-2026.component.html',
  styleUrls: ['./ganadores-egresados-2026.component.scss']
})
export class GanadoresEgresados2026Component implements OnInit, OnDestroy {
  dataNuevos: any[] = [];
  filteredData: any[] = [];
  searchText: string = '';
  p: number = 1;

  constructor() {
    this.loadExcel();
  }

  ngOnInit(): void {
    // La seccion "Nuestra comunidad" (#parthers) vive en el footer
    // compartido, asi que no se puede quitar desde el HTML de esta vista.
    // Se oculta al entrar y se restaura al salir, para no afectar
    // al resto de las rutas.
    $('#parthers').hide();
  }

  // Confeti de bienvenida, el mismo que usan las otras vistas de
  // ganadores (ganador-so3, ganadorso2, ganadoressorteosoportunos):
  // dos chorros, uno de cada lado, durante 2 segundos.
  ngAfterViewInit(): void {
    const duration = 2 * 1000;
    const end = Date.now() + duration;

    (function frame() {
      // Desde la izquierda
      confetti({
        particleCount: 10,
        angle: 60,
        spread: 100,
        origin: { x: 0, y: 0.5 }
      });
      // Desde la derecha
      confetti({
        particleCount: 10,
        angle: 120,
        spread: 100,
        origin: { x: 1, y: 0.5 }
      });

      if (Date.now() < end) {
        requestAnimationFrame(frame);
      }
    })();
  }

  ngOnDestroy(): void {
    $('#parthers').show();
  }

  loadExcel() {
    const url = 'assets/pdf/participantes.xlsx';
    fetch(url)
      .then(response => response.arrayBuffer())
      .then(buffer => {
        const workbook = XLSX.read(buffer, { type: 'array' });

        const sheetNuevos = workbook.Sheets['Recurrentes'];

        this.dataNuevos = XLSX.utils.sheet_to_json(sheetNuevos);

        // Inicializa el filtro con los datos de Nuevos
        this.filteredData = this.dataNuevos;
      })
      .catch(error => console.error('Error loading Excel file:', error));
  }

  filterData() {
    const term = this.searchText.toLowerCase();
    this.filteredData = this.dataNuevos.filter(participante =>
      participante.folio_recurrente.toString().toLowerCase().includes(term) ||
      participante.nombre_pila.toLowerCase().includes(term) ||
      participante.matricula.toLowerCase().includes(term)
    );
  }

  getFirstName(fullName: string): string {
    if (!fullName) return '';
    const nameParts = fullName.split(' ');
    return nameParts[0];

  }

}
